import {
  NewspaperClipping, ChatsCircle, BookOpen, Megaphone, Target, VideoCamera,
} from "@phosphor-icons/react";

export const CONTENT_TYPE_ICONS = {
  "Newsletter": NewspaperClipping,
  "LinkedIn Post": ChatsCircle,
  "Lead Magnet": BookOpen,
  "Blog Post": BookOpen,
  "Email Sequence": Megaphone,
  "Instagram Post": Target,
  "Facebook Post": ChatsCircle,
  "Twitter/X Thread": ChatsCircle,
  "YouTube Script": VideoCamera,
  "Poll": ChatsCircle,
};

export const STATUS_STYLES = {
  planned: { bg: "bg-slate-500/10", text: "text-slate-400", border: "border-slate-500/20", label: "Planned" },
  briefed: { bg: "bg-amber-500/10", text: "text-amber-400", border: "border-amber-500/20", label: "Briefed" },
  generated: { bg: "bg-emerald-500/10", text: "text-emerald-400", border: "border-emerald-500/20", label: "Generated" },
  published: { bg: "bg-blue-500/10", text: "text-blue-400", border: "border-blue-500/20", label: "Published" },
};

export const WEEK_LABELS = ["Week 1", "Week 2", "Week 3", "Week 4"];

export const CONTENT_TYPES = [
  "Newsletter", "LinkedIn Post", "Lead Magnet", "Blog Post",
  "Email Sequence", "Instagram Post", "Facebook Post",
  "Twitter/X Thread", "YouTube Script", "Poll",
];

export function StatusBadge({ status }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.planned;
  return (
    <span className={`px-2 py-0.5 text-[9px] font-medium rounded-full ${s.bg} ${s.text} border ${s.border}`} data-testid={`status-${status}`}>
      {s.label}
    </span>
  );
}

export function PlanStatusBadge({ status }) {
  const map = {
    draft: { bg: "bg-amber-500/10", text: "text-amber-400", label: "Draft" },
    active: { bg: "bg-emerald-500/10", text: "text-emerald-400", label: "Active" },
    completed: { bg: "bg-blue-500/10", text: "text-blue-400", label: "Completed" },
  };
  const s = map[status] || map.draft;
  return <span className={`px-2.5 py-1 text-[10px] font-semibold rounded-full ${s.bg} ${s.text}`}>{s.label}</span>;
}
